<template>
    <div id="chatai_index" class="page_container">
        <div class="page_body_wrapper">
            <div class="page_body">
                <div :class="['page_aside',{'hide':!sldeShow}, site_skin]">
                    <div @click="sldeShow=!sldeShow" :class="['collapse_icon',sldeShow?'fold':'unfold']"></div>
                    <div :class="['aside_wrap',{'overhiden':!sldeShow}]">
                        <div class="slide-top" @click="addDialog">+ 新建会话</div>
                        <div class="slide-list">
                            <div class="dialog-list" v-if="dialog_list.length">
                                <div @click="selectDialog(index)" :class="['dialog-item',{'active':dialogIndex==index}]" v-for="(dia,index) in dialog_list" :key="index" v-if="dia.model==cur_ask_model && selectCateId==dia.cate_id">
                                    <div class="dialog-msg-icon dialog-icon"></div>
                                    <div class="dialog-msg-text"><input :ref="'titleInput'+index" @blur="saveDialog(dia)" class="dialog-msg-input" v-if="dia.editFlag" type="text" v-model="dia.title"><span v-else>{{ dia.title }}</span></div>
                                    <div v-show="dialogIndex==index" @click.stop="editDialog(dia,index)" class="dialog-edit-icon dialog-icon"></div>
                                    <div @click.stop="delDialog(dia, index)" class="dialog-del-icon dialog-icon"></div>
                                </div>
                            </div>
                            <div class="empty-dialog" v-else>
                                <div class="empty-icon"></div>
                                <div class="empty-text">暂无对话</div>
                            </div>
                        </div>
                        <div class="slide-bottom">
                            <div class="slide-btn" @click="clearDialog">
                                <img class="slide-btn-icon" :src="'/static/skin/'+site_skin+'/clear_icon.png'" />
                                <div class="slide-btn-text">清除会话</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page_content" id="eventWrapper">
                    <div :class="['app_container', site_skin]" v-if="selectApplication">
                        <div class="container_top">
                            <div class="top_left">
                                <div class="app_icon"><img :src="require('../components/img/application/app_icon_'+selectApplication.id+'.png')" alt=""></div>
                                <div class="app_info">
                                    <div class="app_name">{{ selectApplication.name }}</div>
                                    <div class="app_desc">{{ selectApplication.desc }}</div>
                                </div>
                            </div>
                            <div class="top_right" @click="appBack"><span class="back_icon"></span>返回{{cur_ask_model}}主页</div>
                        </div>
                        <div class="container_area">
                            <textarea class="area_input" :placeholder="placeholder" :maxlength="maxlength" v-model="inputVal"></textarea>
                            <div class="area_bottom">
                                <button class="clear_btn" @click="inputVal=''">清除</button>
                                <div class="area_info">
                                    <span class="words_count">{{inputVal.length}} / {{maxlength}}</span>
                                    <button class="send_btn" :disabled="!inputVal" @click="sendMsg"><img class="write_icon" src="./img/app_write.png" alt="">开始写</button>
                                </div>
                            </div>
                        </div>
                        <div class="app_center">
                            <div class="app_nav">
                                <div :class="['nav_item',{'active':appNavIndex == index}]" v-for="(nav,index) in navList" :key="index" @click="appNavIndex=index">{{ nav }}</div>
                            </div>
                            <div class="open_vip">
                                <template v-if="cur_ask_model=='Chat3.5'">
                                    <img class="vip_icon" :src="'/static/skin/'+site_skin+'/is_vip.png'" alt="">
                                    <div class="vip_text" v-if="userInfo.is_vip==1">Chat3.5会员到期时间：{{ userInfo.vip_end_date }}</div>
                                    <div class="vip_text"  v-else>可用创作次数：{{ userInfo.score_balance }}次，开通会员不限次数</div>
                                </template>
                                <template v-else>
                                    <img class="vip_icon" :src="'/static/skin/'+site_skin+'/gpt4vip.png'" alt="">
                                    <div class="vip_text">剩余：{{userInfo.word_balance}}字，购买4.0字数包，限时优惠中…</div>
                                </template>
                                <button class="pay_btn" @click="showVipPopup = true">点此购买</button>
                            </div>
                        </div>
                        <div class="example_part" v-if="appNavIndex == 0">
                            <div class="example_item" v-for="(ex,index) in appExmapleList" :key="ex.id">
                                <span class="example_num">实例{{ index+1 }}：</span>{{ ex.content }} <button class="use_btn" @click="inputVal=ex.content">使用</button>
                            </div>
                        </div>
                    </div>
                    <div class="content_body" ref="scrollWrap">
                        <div class="show_banner" v-if="currentDialog.length == 0 && !selectApplication">
                            <div class="chat-title">人工智能Chat Ai对话机器人</div>
                            <div class="tips-content">
                                <div class="tip_title">
                                    <img class="tip_title_icon" src="./img/ai-work.svg" alt="" srcset="">
                                    <div class="tititle_label">有趣的提问</div>
                                </div>
                                <div class="tip_title">
                                    <img class="tip_title_icon" src="./img/interest-question.svg" alt="" srcset="">
                                    <div class="tititle_label">解决工作难题</div>
                                </div>
                                <div class="tip_title">
                                    <img class="tip_title_icon" src="./img/love-chat.svg" alt="" srcset="">
                                    <div class="tititle_label">高情商聊天技巧</div>
                                </div>
                                <div @click="inputVal=tip.content" class="tips-item" v-for="tip in tip_list" :key="tip.id">
                                    <div class="tips-item-content">{{ tip.content }}</div>
                                </div>
                            </div>
                            <div class="qun_ad" v-if="isLogin">
                                <div class="code_content">
                                    <div class="qun_top">
                                        <img class="qun_head" src="./img/qun.jpg" alt="">
                                        <div class="qun_info">
                                            <div class="qun_name">{{site_skin=="default"?"首选AI":"超思AI"}}粉丝福利群<span>(禁广告)</span></div>
                                            <div class="qun_desc">超过100000+人加入</div>
                                        </div>
                                    </div>
                                    <img class="qun_code" :src="qywx_qr_code?qywx_qr_code:'./img/qun.jpg'" alt="">
                                    <div class="qun_label">微信扫一扫，添加到通讯录，邀请你进群</div>
                                </div>
                                <div class="qun_tips">
                                    <div class="tips_title">群友须知</div>
                                    <p>01、请务必遵从群规，正常学习交流!</p>
                                    <p>02、严禁广告，散播不实信息，发布涉政，黄等违法言论!</p>
                                    <p>03、被踢或主动退出福利群，不得再次入群请谨慎!</p>
                                </div>
                            </div>
                        </div>
                        <div class="msg-wrap" ref="msgWrap" v-if="(!selectApplication && currentDialog.length != 0) || selectApplication && appNavIndex == 1" :style="selectApplication?'padding:0;':''">
                            <div class="msg-item vditor-reset" v-for="(msg,index) in currentDialog" :key="index">
                                <div :class="['msg-content',msg.speaker=='server'?'left':'right']" v-if="msg.content">
                                    <img class="user-img" v-if="msg.speaker=='server'" src="./img/server_avatar2.png" />
                                    <img class="user-img" v-else :src="userInfo.avatarurl?userInfo.avatarurl:'/static/img/my_avatar.png'" />
                                    <div class='content-item' :class="{'fullline':(msg.content.includes('language-')||(msg.renderHtml&&msg.renderHtml.includes('language-')))}">
                                        <div class="copy-item">
                                            <img v-if="index==currentDialog.length-1&&sending" @click="stopReply(msg)" class="copy-icon" src="./img/stop.png" />
                                            <img v-else @click="copytext(msg.content)" class="copy-icon" src="./img/copy_icon.png" />
                                        </div>
                                        <div class="text_content">
                                            <div v-if="msg.speaker=='server'" class="msg-userinfo msg-userinfo_left">{{cur_ask_model}}<span>{{ msg.add_time }}</span></div>
                                            <div v-else class="msg-userinfo msg-userinfo_right"><span>{{ msg.add_time }}</span>{{userInfo.nickname}}</div>
                                            <div class="detail_loading msg-text" v-if="msg.loading">
                                                <img class="loading_icon" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=" />
                                                <div class="loading_text">思考中，请稍后...</div>
                                            </div>
                                            <div v-else-if="msg.content" :class="['msg-text',index==currentDialog.length-1&&sending ? 'typeing' : '']" v-html="msg.renderHtml||msg.content"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content_footer" v-if="!selectApplication">
                        <div :class="['footer_wrap', site_skin]">
                            <!-- <div class="footer_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 17H4V5h8V3H4c-1.1 0-2 .9-2 2v12a2 2 0 0 0 2 2h4v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h4c1.1 0 2-.9 2-2v-3h-2v3z"></path><path fill="currentColor" d="M17.71 13.29L21.3 9.7a.996.996 0 1 0-1.41-1.41L18 10.17V4c0-.55-.45-1-1-1s-1 .45-1 1v6.17l-1.89-1.88A.996.996 0 1 0 12.7 9.7l3.59 3.59c.4.39 1.03.39 1.42 0z"></path></svg>
                                <div class="icon_tips">下载安装Talking Ai</div>
                            </div> -->
                            <div class="footer_icon" @click="downLoadExcel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.495v20.846a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99zM4 4.735v14.53l10 1.429V3.306L4 4.735zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4v-2zm-6.8-7l2.8 4h-2.4L9 13.714L7.4 16H5l2.8-4L5 8h2.4L9 10.286L10.6 8H13l-2.8 4z"></path></svg>
                                <div class="icon_tips">下载Excel格式会话记录</div>
                            </div>
                            <div class="footer_icon" @click="downLoadImage">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22.71 6.29a1 1 0 0 0-1.42 0L20 7.59V2a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 .33.21a.94.94 0 0 0 .76 0a1 1 0 0 0 .33-.21l3-3a1 1 0 0 0 0-1.42ZM19 13a1 1 0 0 0-1 1v.38l-1.48-1.48a2.79 2.79 0 0 0-3.93 0l-.7.7l-2.48-2.48a2.85 2.85 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1ZM5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0l3.17 3.17l4.3 4.3Zm13-1a.89.89 0 0 1-.18.53L13.31 15l.7-.7a.77.77 0 0 1 1.1 0L18 17.21Z"></path></svg>
                                <div class="icon_tips">下载图片格式会话记录</div>
                            </div>
                            <div class="footer_main">
                                <div class="footer_top">
                                    <div class="footer_top_left">
                                        <div class="tool_btn" @click="appDrawerVisible=true">
                                            <img class="tool_btn_icon" src="./img/robot.png" alt="">
                                            <div class="tool_btn_text">AI提问工具{{ ask_model }}</div>
                                            <div class="btn_badge">新</div>
                                        </div>
                                        <!-- <div class="select_question" v-if="selectApplication">
                                            <span>{{ selectApplication.name }}</span>
                                            <svg @click="clearApplication" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="#FF722C" d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z"></path></svg>
                                        </div> -->
                                    </div>
                                    <!-- <div class="footer_top_right">
                                        <div class="tool_btn_share" @click="btnShare">
                                            <img class="tool_btn_icon" src="./img/share-icon.svg" alt="">
                                            <div class="tool_btn_text">分享加次数</div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="input_wrap">
                                    <textarea class="input_area" v-model="inputVal" @keydown.enter.exact="sendMsg" :maxlength="maxlength" :placeholder="placeholder"></textarea>
                                    <div class="input_place">"{{inputVal}}"</div>
                                </div>
                            </div>
                            <button class="send_btn" :disabled="!inputVal" @click="sendMsg"><img src="./img/send.png" alt=""></button>
                        </div>
                    </div>
                </div>
                <div :class="['page_right_aside',{'hide':!appDrawerVisible}]">
                    <div @click="appDrawerVisible=!appDrawerVisible" :class="['collapse_icon',appDrawerVisible?'fold':'unfold']"></div>
                    <appdrawer ref="appdrawer" @change="selectApp" :visible.sync="appDrawerVisible" :askModel="cur_ask_model"></appdrawer>
                </div>
            </div>
        </div>
        <vipshare v-if="vipshareVisible" :showPopup.sync="vipshareVisible"></vipshare>
        <vipconfirm v-if="vipConfirmVisible" :from="confirmFrom" @confirm="vipConfirm"></vipconfirm>
        <vippanel v-if="showVipPopup" :from="vipFrom" :type="vipOpenType" :showPopup.sync="showVipPopup" @confirm="vipPopupConfirm"></vippanel>
        <pwapanel ref="pwapanel" v-if="deferredPrompt"></pwapanel>
        <identify ref="refIdentify" @validate="validateCode"></identify>
        <verified ref="refIerified"></verified>
        <deskapppanel ref="deskapp"></deskapppanel>
    </div>
</template>
<script type="text/ecmascript-6">
    import VditorPreview from 'vditor/dist/method.min'
    import "vditor/dist/index.css"
    import html2canvas from "html2canvas";
	import fetchRequest from "../plugins/fetch.js"
    import bounceloadings from "COMPONENTS/Bounceloadings.vue"
    import vippanel from "COMPONENTS/VipPanel.vue"
    import vipconfirm from "COMPONENTS/VipConfirm.vue"
    import appdrawer from "COMPONENTS/AppDrawer.vue"
    import vipshare from "COMPONENTS/VipShare.vue"
    import pwapanel from "COMPONENTS/PwaPanel.vue"
    import deskapppanel from "COMPONENTS/DeskAppPanel.vue"
    import newusercoupon from "COMPONENTS/NewUserCoupon.vue"
    import identify from "COMPONENTS/Identify.vue"
    import verified from "COMPONENTS/VerifiedPanel.vue"
    export default {
        components:{bounceloadings, vippanel, vipconfirm, vipshare, pwapanel, appdrawer, newusercoupon, identify, verified, deskapppanel },
        data() {
            return {
                deferredPrompt:null,//是否已经安装了快应用的一个promise
				tip_list:[],
                hot_id_list:[],
                df_avatar:require("./img/df_avatar.png"),
                inputVal:"",
                score:0,
				dialog_list:[],
				dialogIndex:0,
				controller:null,
                sending:false,
                sldeShow:true,
                showVipPopup:false,
                vipFrom:0,
                vipOpenType:1,
                vipConfirmVisible:false,
                appDrawerVisible:true,
                selectApplication:null,
                downloadImg:false,
                loadExcel:false,
                vipshareVisible:false,
                confirmFrom:0,
                cur_chat_id:0,
                cur_ask_model:"Chat3.5",
                change_model:false, // 模型切换
                qywx_qr_code:"",
                inputVal:"",
                navList:["实例演示","生成内容"],
                appNavIndex:0,
                appExmapleList:[],
                dialogData:[],
                site_skin:''
            }
        },
        created() {
            let skin = this.$route.query.skin || '';
            if(skin){
                SiteSkin = skin
                APP_ID = Skin_APP_ID
                SiteTitle = Skin_SiteTitle
                MAIN_URLROOT = Skin_MAIN_URLROOT
            }
            this.site_skin = SiteSkin
            let token = this.$route.query.token || '';
            if(token){
                localStorage.setItem("token", token);
            }
            this.inputVal = this.$route.query.input || '';
            // 媒体ID
            localStorage.setItem("ad_account_id", this.$route.query.adaid || '');
            // 站点ID
            localStorage.setItem("site_id", this.$route.query.site_id || '');

            // 搜索关键词
            localStorage.setItem("keyword", this.$route.query.q || '');

            // 邀请码
            let invite_code = this.$route.query.invite_code || '';
            localStorage.setItem("invite_code", invite_code);

            // 百度广告参数
            localStorage.setItem("bd_vid", this.$route.query.bd_vid || '');

            // 360搜索推广参数
            localStorage.setItem("qhclickid", this.$route.query.qhclickid || '');

            // 360展示广告参数
            localStorage.setItem("sourceid", this.$route.query.sourceid || '');

            // 日期参数
            localStorage.setItem("timestamp", this.$route.query.timestamp || '');

            
            //判断url中是否带有token
            let resu = location.href.indexOf('token')
            if(resu > 0){
                let href = location.href
                let params = this.getUrlParams(href)
                href = href.replace("token="+params.token, "").replace("?&", "?")
                location.href = href
            }
            this.getDialogList();
            this.getData();
            this.score = this.$store.state.userInfo.score_balance || 0;
            this.getQywxCode()

            // 上报数据
            let params = {ad_account_id:this.$route.query.adaid || 0, site_id:this.$route.query.site_id||0, keyword:this.$route.query.q || '', 
            bd_vid:this.$route.query.bd_vid || '', qhclickid:this.$route.query.qhclickid || '', sourceid:this.$route.query.sourceid || '', timestamp:this.$route.query.timestamp || '', source:SiteSource}
            if(params.keyword){
                this.$http.get("/front/wx/imagecode/?authorizer_appid=adfrom", {params:params}).then((res)=>{
                })
            }
        },
        mounted(){
            let that = this;
            document.getElementById("eventWrapper").addEventListener("click",function(e){
                if(e.target.classList.contains("vipPopShow")){
                    that.vipOpenType = 1
                    that.showVipPopup = true;
                }else if(e.target.classList.contains("vipPopShowWord")){
                    that.showVipPopup = true;
                    that.vipOpenType = 2
                }
            })
            setTimeout(()=>{
                this.deferredPrompt = deferredPrompt;
                if(deferredPrompt&&this.isLogin==1){
                    this.$nextTick(()=>{
                        // this.$refs.pwapanel.show();
                    })
                }
                if(this.$store.state.userInfo.is_auth_bind == 0){
                    // this.$refs.refIerified.show();//实名认证弹窗
                }
                // if(this.$store.state.userInfo.is_install_desk == 0){
                //     this.$refs.deskapp.show();//安装桌面应用弹窗
                // }
            },1000)
            if(this.dialog_list.length > 0){
                this.$nextTick(()=>{
                    this.vditorRender();
                })
            }
        },
		watch:{
			dialog_list:{
				handler(val){
                    // if(this.selectApplication) return
					if(val.length){
						localStorage.setItem("dialogArray",JSON.stringify(val))
					}else{
						localStorage.removeItem("dialogArray")
					}
				},
				deep: true
			}
		},
		computed:{
			currentDialog(){
                // if(this.selectApplication) return this.dialogData ? this.dialogData : []
                if(this.dialogIndex==0){
                    let flag = false
                    let i = 0
                    this.dialog_list.forEach((dia)=>{
                        if(dia.model == this.ask_model && dia.cate_id == this.selectCateId){
                            this.dialogIndex = i
                            flag = true
                        }else{
                            i = i + 1
                        }
                    })
                    if(!flag){
                        this.dialogIndex = 0
                        return []
                    }
                }
				let dialog = this.dialog_list[this.dialogIndex];
                if(dialog){
                    this.appNavIndex = 1
                }
				return dialog ? dialog.msgList : []
			},
			title(){
				let dialog = this.dialog_list[this.dialogIndex];
				return dialog ? dialog.title : "新聊天对话"
			},
            userInfo(){
                return this.$store.state.userInfo;
            },
            isLogin(){
                return this.$store.state.isLogin;
            },
            ask_model(){
                console.log("ask_model")
                let _ask_model = this.$route.query.model||'Chat3.5'

                this.change_model = false
                if(this.cur_ask_model != _ask_model){
                    this.cur_ask_model = _ask_model
                    this.change_model = true
                    this.confirmAddByChangeModel()
                }
                return _ask_model
            },
            placeholder(){
                let leftStr = this.cur_ask_model == "Chat3.5" ? (this.userInfo.is_vip==1?'':this.isLogin==true?'（剩余'+this.userInfo.score_balance+'次数）':'') : (this.isLogin==true?'（剩余'+this.userInfo.word_balance+'字)':'');
                if(this.selectApplication){
                    return this.selectApplication.desc + leftStr;
                }else{
                    let pStr = this.cur_ask_model == "Chat3.5" ? "体验智能Ai对话—首选Ai(单次最多输入1000字)" : "体验智能Ai对话—首选Ai(单次最多输入4000字)";
                    return pStr + leftStr;
                }
            },
            maxlength(){
                return this.cur_ask_model=='Chat3.5' ? 1000 : 4000
            },
            selectCateId(){
                return this.selectApplication?this.selectApplication.id:0
            }
		},
        methods: {
            getUrlParams(url) {
                // 通过 ? 分割获取后面的参数字符串
                let urlStr = url.split('?')[1]
                // 创建空对象存储参数
                let obj = {};
                // 再通过 & 将每一个参数单独分割出来
                let paramsArr = urlStr.split('&')
                for(let i = 0,len = paramsArr.length;i < len;i++){
                    // 再通过 = 将每一个参数分割为 key:value 的形式
                    let arr = paramsArr[i].split('=')
                    obj[arr[0]] = arr[1];
                }
                return obj
            },
            checkLogin(){
                // 检查登录状态
                if(!this.isLogin){
                    this.$showLogin();
                    return false;
                }else{
                    return true;
                }
            },
            getDialogList(){
                let dialogArr = localStorage.getItem("dialogArray");
                if(dialogArr){
                    dialogArr = JSON.parse(dialogArr);
                    console.log("dialogArr=", dialogArr)
                    dialogArr.forEach((dia)=>{
                        dia.msgList.forEach(msg=>{
                            if(msg.loading){
                                msg.loading = false;
                                // msg.content = "网络走丢了，请重新提问"
                                msg.content = ""
                            }
                        })
                    })
                }else{
                    dialogArr = [];
                }
                this.dialog_list = dialogArr;
            },
            getQywxCode() {
                // 获取员工二维码
                this.$http.get('/wap/qywx/user/?ctype=img&wxuid='+this.userInfo.wxuid).then((res) => {
					this.qywx_qr_code = res.qr_code
				})
			},
			getData() {//获取热门分类
                this.$loading.show();
                this.$http.get('/front/chatai/category/?enume_id=5').then((res) => {
					if (res.status == 200) {
						this.hot_id_list = res.data.data.map(hot=>hot.id);
						this.hotId = res.data.data[0].id;
						this.getAsk(this.hotId,true)
					} else {
						this.$toast(res.message)
					}
				}).finally((res)=>{
                    this.$loading.hide();
                });
			},
			getAsk(hotId,scrollFlag){
                this.$http.get('/front/chatai/ask/?cate_id='+hotId+'&page=1').then((res) => {
					if (res.status == 200) {
						this.tip_list = this.randomArray(res.data.data);
                        if(this.currentDialog.length) this.scrollToBottom();
					} else {
                        this.$toast(res.message)
					}
				})
			},
            //新增对话
			addDialog(){
                if(!this.checkLogin()) return
				if(this.sending){
                    this.$confirm('本次作答没有完成，创建新会话将停止本次作答？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.sending = false;
                        try{
                            this.controller.abort();
                            this.controller = null;
                        }catch(e){}
                        this.confirmAdd();
                    })
				}else{
					this.confirmAdd();
				}
			},
            confirmAddByChangeModel(){
                // 切换模型时创建新会话
                // if(!this.checkLogin()) return
                console.log("切换模型时创建新会话")
                if(this.$refs.appdrawer){
                    this.$refs.appdrawer.cancelSelect()
                }
                this.selectApplication = null
                this.getData()
                let curIndex = -1
                // let curDialogList = this.dialog_list.filter((pay)=>pay.model !== this.cur_ask_model);
                // this.dialog_list = curDialogList;
                // console.log("curDialogList=", curDialogList)
                this.dialog_list.forEach((element, index) => {
                    if(element.model == this.ask_model && curIndex == -1 && element.cate_id == this.selectCateId){
                        curIndex = index
                    }
                });
                this.dialogIndex = curIndex
			},
			confirmAdd(){
                if(!this.checkLogin()) return
                let data = {
                    msgList: [],
                    title: "新聊天对话",
                    editFlag: false,
                    id:0,
                    ctype:this.cur_ask_model,
                    model:this.cur_ask_model,
                    cate_id:this.selectApplication?this.selectApplication.id:0
                }
                this.$http.post('/front/chatai/chat/group/', data).then((res) => {
					if (res.status == 200) {
                        //给新增的聊天添加id
						data.id=res.data.id
                        this.dialog_list.unshift(data)
					} else {
                        this.$toast(res.message)
					}
				})
				try{
					this.dialogIndex = 0;
					this.controller.abort();
					this.controller = null;
				}catch(e){}
			},
			delDialog(dia, index){
                if(!this.checkLogin()) return
                this.$confirm('确定要删除对话？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.dialog_list.splice(index,1);
                    this.dialogIndex = 0;
                    this.$http.delete(`/front/chatai/chat/group/${dia.id}/`).then((res) => {
                    	if (res.status == 200) {
                            
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
                })
			},
            editDialog(dia, index){
                if(!this.checkLogin()) return
                dia.editFlag=true;
                this.$nextTick(()=>{
                    this.$refs['titleInput'+index][0].focus();
                })
            },
            saveDialog(dia){
                if(!this.checkLogin()) return
                dia.editFlag=false;
                this.$http.put(`/front/chatai/chat/group/${dia.id}/`, dia).then((res) => {
					if (res.status == 200) {
					} else {
                        this.$toast(res.message)
					}
				})
            },
			clearDialog(){
                if(!this.checkLogin()) return
                this.$confirm('确定要删除对话？', '提示', {
                    type: 'warning'
                }).then(() => {
                    let curDialogList = this.dialog_list.filter((pay)=>!(pay.model == this.ask_model && pay.cate_id == this.selectCateId));
                    this.dialog_list = curDialogList;
                    this.dialogIndex = 0;
					this.scrollToBottom();
                    if(this.sending){
                        this.sending = false;
                        try{
                            this.controller.abort();
                            this.controller = null;
                        }catch(e){}
                    }
                    this.$http.delete(`/front/chatai/chat/group/?ctype=${this.ask_model}&cate_id=${this.selectCateId}`).then((res) => {
                    	if (res.status == 200) {
                            
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
                })
			},
            //选择对话框
			selectDialog(index){
                if(!this.checkLogin()) return
				if(this.sending){
                    this.$confirm('本次作答没有完成，切换会话将停止本次作答？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.sending = false;
                        try{
                            this.controller.abort();
                            this.controller = null;
                        }catch(e){}
                        this.confirmSelect(index);
                    })
				}else{
					this.confirmSelect(index);
				}
			},
			confirmSelect(index){
				try{
                    this.appNavIndex = 1
                    // if(this.selectApplication){
                    //     this.$http.get(`/front/chatai/chat/?group_id=${this.cur_ask_model}`).then((res) => {
                    //        // 接口获取数据
                    //     })
                    // }
                    this.dialogIndex = index;
                    this.vditorRender();
                    this.controller.abort();
                    this.controller = null;
				}catch(e){}
			},
			randomArray(arr){
				let len = arr.length;
				if(len <= 9){
					return arr
				}else{
					let arrNew = [];
					while(arrNew.length < 9){
						let _num = Math.floor(Math.random()*len)
						let ex = arr[_num];
						if(arrNew.length == 0){
							arrNew.push(ex);
						}else{
							let flag = arrNew.some(item=>item.id==ex.id);
							if(!flag) arrNew.push(ex)
						}
					}
					return arrNew;
				}
			},
            validateCode(code){
                if(code){
					this.submitQuestion({chat_id:this.cur_chat_id, code_num:code})
				}else{
                    this.$toast("请输入验证码");
				}
            },
            //发送消息
			sendMsg(){
                if(!this.checkLogin()) return
                this.inputVal = this.inputVal.trim();
                localStorage.setItem("inputVal", this.inputVal);
                event.preventDefault();
				
				if(!this.inputVal){
                    this.$toast('请输入内容')
					return
				}
                
				if(this.sending){
                    this.$toast('请等待上次作答完成')
					return
				}
                if(this.selectApplication){
                    this.appNavIndex = 1
                }
				let list = this.dialog_list;
                let curDialogList = this.dialog_list.filter((pay)=>pay.model == this.ask_model && pay.cate_id == this.selectCateId);
                console.log(this.ask_model, this.dialogIndex, curDialogList)
				if(curDialogList.length == 0 || this.dialogIndex == -1){
					list.push({
						msgList:[],
						title:this.inputVal,
                        editFlag:false,
                        id:0,
                        model:this.ask_model,
                        cate_id:this.selectApplication?this.selectApplication.id:0
					})
                    this.dialogIndex = list.length - 1
                    this.$http.post('/front/chatai/chat/group/',{ title: this.inputVal, ctype:this.ask_model, cate_id:this.selectApplication?this.selectApplication.id:0}).then((res) => {
                    	if (res.status == 200) {
                            //给新增的聊天添加id
                    		list[list.length-1].id=res.data.id
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
				}
				this.currentDialog.push({
						speaker: 'customer',
						contentType: 'text',
						content: this.inputVal,
                        add_time:""
					},{
						speaker: 'server',
						contentType: 'text',
						content: 'AI正在思考，请稍等',
						type:'-1',
						loading:true,
                        add_time:""
					}
				)
				this.scrollToBottom()
				//发起请求
				let data = {
					cate_id:0,
					question: this.inputVal,
                    group_id:list[this.dialogIndex].id
				}
                if(this.selectApplication){
                    // 应用
                    data.cate_id = this.selectApplication.id
                }
				// 同步请求
				this.submitQuestion(data); 
			},
            showVipPoup(){
                alert("showVipPoup")
            },
			submitQuestion(data){
				// 提交问题
				let that = this;
                data.question = this.inputVal
				this.sending = true;
				data.stream = 1; // 流式处理
                data.source = SiteSource;
                data.ask_model = this.cur_ask_model
				let lastMsg = this.currentDialog[this.currentDialog.length-1];
                this.$http.post('/front/chatai/chat/',data).then((res) => {
					if(res.status == 200){
                        this.currentDialog[this.currentDialog.length-2].id = res.data.chat_id;
                        this.currentDialog[this.currentDialog.length-2].add_time = res.data.add_time;
						
                        this.cur_chat_id = res.data.chat_id;
						this.score = res.data.score;
						let is_code_valid = res.data.is_code_valid;
                        lastMsg.add_time = res.data.add_time
						if(this.score == 0 && this.cur_ask_model == "Chat3.5"){
							lastMsg.content = "您的次数已用尽，开通会员畅享无限对话，<span class='vipPopShow' style='color:red;cursor:pointer;'>立即开通会员<span>";
							lastMsg.loading = false;
							this.sending = false;
                            this.vipConfirmVisible = true;
                            this.confirmFrom = 0
						}else if(this.score == 0 && this.cur_ask_model == "Chat4.0"){
							lastMsg.content = "您的字数包已用完，请充值字数包畅享4.0对话，<span class='vipPopShowWord' style='color:red;cursor:pointer;'>立即充值字数<span>";
							lastMsg.loading = false;
							this.sending = false;
                            this.vipConfirmVisible = true;
                            this.confirmFrom = 2
						}else if(is_code_valid == 1){
							// 提示验证码
							this.$refs.refIdentify.show()
						}else if(is_code_valid == 4){
							// 验证码错误
							this.$refs.refIdentify.show()
							this.$toast("验证码错误");
						}else{
                            this.$refs.refIdentify.init()
							this.$refs.refIdentify.popClose()
				            this.inputVal = "";
							// 发送消息
							this.fetchMsg(res.data.chat_id, this.change_model)
						}
					}else{
						// lastMsg.content = res.message;
						// lastMsg.loading = false;
						this.sending = false;
                        //
                        if(res.message.indexOf("您提问的内容包含违禁词")> -1){
                            lastMsg.content = ""
                            let last2Msg = this.currentDialog[this.currentDialog.length-2];
                            last2Msg.content = "<span style='color:red;'>内容可能违反国家政策，请重新输入</span>"
                        }else{
                            lastMsg.content = res.message;
						    lastMsg.loading = false;
                        }
					}
					this.scrollToBottom();
				})
			},
			fetchMsg(id, change_model) {
				let chat_ids = [];
				this.currentDialog.forEach(dia=>{
					if(dia.id) chat_ids.push(dia.id)
				})
                if(change_model){
                    // 切换模型了
                    chat_ids = []
                }
                if(this.selectApplication){
                    // 应用
                    chat_ids = []
                }
                
				this.controller = fetchRequest('/api/front/chatai/chat/stream/',{chat_id:id,chat_ids},(res,startFlag)=>{
					let lastMsg = this.currentDialog[this.currentDialog.length-1];
					if(res == "JDYBLACK"){
						lastMsg.content = "智能AI机器人回答的的内容包含有违反中国法律法规的内容，请修改后重新提问！\n\n为了平台的健康绿色发展，请勿在平台内提问政治、色情相关的内容，感谢您的理解和支持！"
						this.sending = false;
						this.controller.abort();
						this.controller = null;
						this.renderHtml(lastMsg);
					}else if(res == "#end#"){
						this.sending = false;
						this.controller = null;
                        this.renderHtml(lastMsg);
                        this.vipPopupConfirm()
					}else{
						if(startFlag){
							lastMsg.type = 1
							lastMsg.content = ""
							lastMsg.loading = false
						}
						lastMsg.content += res;
						this.scrollToBottom();
					}
				});
			},
            renderHtml(lastMsg){
                VditorPreview.md2html(lastMsg.content).then(res=>{
                    this.$set(lastMsg,'renderHtml',res)
                    this.vditorRender();
		        })
            },
			//停止回复
			stopReply(msg){
				try{
					this.controller.abort();
					this.sending = false;
					this.controller = null;
                    if(!msg.content) msg.content = "您已停止接收回复~"
				}catch(e){}
			},
            copytext (text) {
                const el = document.createElement('textarea')
                el.setAttribute('readonly', 'readonly')
                el.style.position = 'absolute'
                el.style.left = '-9999px'
                el.value = text
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                this.$toast("复制成功");
            },
            btnShare(){
                if(!this.checkLogin()) return
                this.vipshareVisible = true
            },
            downLoadExcel(){
                if(!this.checkLogin()) return
                if(this.userInfo.is_vip==0){
                    this.vipConfirmVisible = true
                    this.confirmFrom = 1;
                    return;
                }
                let group_id = 0
                if(this.dialog_list.length&&this.dialog_list[this.dialogIndex].msgList.length&&!this.loadExcel){
                    this.loadExcel = true;
                    group_id = this.dialog_list[this.dialogIndex].id
                    let downloadUrl = API_SERVER+'/api/front/chatai/chatexport/?group_id=' + group_id;
                    this.downloadExcel(downloadUrl, this.dialog_list[this.dialogIndex].title + ".xlsx").finally((res)=>{
                        this.loadExcel = false;
                    })
                }else{
                    if(this.loadExcel){
                        this.$toast("Excel正在下载中，请稍后...")
                    }else{
                        this.$toast("当前对话暂无信息")
                    }
                }
            },
            downLoadImage(){
                if(!this.checkLogin()) return
                if(this.userInfo.is_vip==0){
                    this.vipConfirmVisible = true
                    this.confirmFrom = 1;
                    return;
                }
                if(this.dialog_list.length&&this.dialog_list[this.dialogIndex].msgList.length&&!this.downloadImg){
                    this.downloadImg = true;
                    html2canvas(this.$refs.msgWrap,{
                        useCORS: true,
                        width: this.$refs.msgWrap.scrollWidth,
                        height: this.$refs.msgWrap.scrollHeight
                    }).then((canvas)=>{
                        let link = document.createElement('a');
                        //图片转成base64格式
                        link.href = canvas.toDataURL("image/png");
                        link.download = this.dialog_list[this.dialogIndex].title;
                        link.click();
                        this.downloadImg = false;
                    })
                }else{
                    if(this.downloadImg){
                        this.$toast("图片正在下载中，请稍后...")
                    }else{
                        this.$toast("当前对话暂无信息")
                    }
                }
            },
            //确认去开通，显示开通弹窗
            vipConfirm(res){
                this.vipConfirmVisible = false
                if(res){
                    this.showVipPopup = true;
                    if(this.cur_ask_model =="Chat3.5"){
                        this.vipFrom = 1;
                        this.vipOpenType = 1
                    }else{
                        this.vipFrom = 1;
                        this.vipOpenType = 2
                    }
                }
            },
            vipPopupConfirm(){
                let invite_code = localStorage.getItem("invite_code")||"";
                this.$http.get('/front/my/profile/?invite_code='+ invite_code+'&app_id='+APP_ID).then(res =>{
                    if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
                    }else{
                        this.$toast(res.message)
                    }
                })
            },
            clearApplication(){
                this.selectApplication = null;
            },
            appBack(){
                this.$refs.appdrawer.cancelSelect();
                this.selectApplication = null;
                this.inputVal = "";
                this.dialogIndex = 0;
                this.getDialogList();
            },
            selectApp(data){
                if(this.selectCateId == data.id){
                    this.selectApplication = null
                    return
                }
                this.selectApplication = data;
                this.appNavIndex = 0
                // this.selectCateId = data.id;
                this.inputVal = "";
                this.dialogIndex = 0;
                // this.$http.get(`/front/chatai/chat/group/?ctype=${this.cur_ask_model}&cate_id=${data.id}`).then((res) => {
				// 	if (res.status == 200) {
                //         this.dialog_list = res.data.data_list;
                //         this.getDialogData();
				// 	}
				// })
                this.$http.get('/front/chatai/ask/?cate_id='+data.id+'&page=0').then((res) => {
                    if (res.status == 200) {
                        this.appExmapleList = res.data.data
                    }
                });
                this.vditorRender();
            },
            getDialogData(){
                let id = this.dialog_list[this.dialogIndex] ? this.dialog_list[this.dialogIndex].id : 0;
                if(!id){
                    this.dialogData = []
                    return
                }
                this.$http.get('/front/chatai/chat/?group_id='+id).then((res) => {
					if (res.status == 200) {
                        this.dialogData = res.data.item_list;
                        this.scrollToBottom();
					} else {
                        this.$message.error(res.message)
					}
				})
            },
            scrollToBottom(){
                this.$nextTick(()=>{
                    let scrollWrap = this.$refs.scrollWrap;
                    scrollWrap.scrollTop = scrollWrap.scrollHeight;
                })
            },
            vditorRender(){
                this.$nextTick(()=>{
                    if(this.currentDialog.length){
                        VditorPreview.mindmapRender(this.$refs.msgWrap)
                        VditorPreview.mathRender(this.$refs.msgWrap)
                        VditorPreview.mermaidRender(this.$refs.msgWrap)
                        VditorPreview.chartRender(this.$refs.msgWrap)
                        VditorPreview.highlightRender(this.$refs.msgWrap)
                        VditorPreview.codeRender(this.$refs.msgWrap)
                        this.scrollToBottom();
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .page_container{
        display: flex;
        width: 100%;
        height: 100%;
        min-width: 1300px;
        min-height: 600px;
        background-color: #fff;
        overflow: hidden;
        flex-direction: column;
        
        .page_header{
            height: 60px;
            background-color: #dbefe4;
            flex-grow: 0;
            flex-shrink: 0;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0 4px 6px -1px #cecece,0 2px 4px -2px #cecece;
            .header_left{
                display: flex;
                align-items: center;
                .header_logo{
                    // width: 120px;
                    height: 45px;
                    margin-right: 20px;
                }
            }
            .fold{
                background-image: url("./img/menu_fold.png");
            }
            .unfold{
                background-image: url("./img/menu_unfold.png");
            }
        }
        .page_body_wrapper{
            flex-grow: 1;
            overflow: hidden;
            padding: 16px;
            .page_body{
                height: 100%;
                overflow: hidden;
                display: flex;
                box-shadow: 0 4px 6px -1px #ccc,0 2px 4px -2px #ccc;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                .page_aside{
                    width: 260px;
                    flex-shrink: 0;
                    border-right: 1px solid #e5e7eb;
                    transition: width 0.3s;
                    position: relative;
                    &.hide{
                        width: 0;
                    }
                    .collapse_icon{
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                        background-color: #fff;
                        border-radius: 50%;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 0 4px 2px #eee;
                        cursor: pointer;
                        &::after{
                            content: "";
                            width: 7px;
                            height: 7px;
                            border: 1px solid #666;
                            border-top: none;
                            border-right: none;
                            position: absolute;
                            top: 7px;
                            transform-origin: center center;
                        }
                        &.fold::after{
                            transform: rotate(45deg);
                            left: 8px;
                        }
                        &.unfold::after{
                            transform: rotate(225deg);
                            left: 7px;
                        }
                    }
                    .aside_wrap{
                        height: 100%;
                        padding: 16px 0;
                        display: flex;
                        flex-direction: column;
                        &.overhiden{
                            overflow: hidden;
                        }
                        .slide-top{
                            flex-grow: 0;
                            flex-shrink: 0;
                            cursor: pointer;
                            border-radius: 5px;
                            border: 1px dashed #379a63;
                            height: 46px;
                            padding: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #379a63;
                            font-size: 13px;
                            user-select: none;
                            overflow: hidden;
                            margin: 0 16px;
                            white-space: nowrap;
                        }
                        .slide-list{
                            flex-grow: 1;
                            overflow: hidden;
                            padding: 12px 0;
                            height: 0;
                            .dialog-list{
                                overflow-y: scroll;
                                margin-right: -17px;
                                height: 100%;
                                padding: 0 16px;
                                .dialog-item{
                                    margin-bottom: 10px;
                                    display: flex;
                                    align-items: center;
                                    padding: 13px;
                                    border-radius: 5px;
                                    overflow: hidden;
                                    border: 1px solid #e5e7eb;
                                    cursor: pointer;
                                    &:hover{
                                        box-shadow: 0 0 3px 0px #acedc9;
                                        border-color: #acedc9;
                                    }
                                    &.active{
                                        border-color: #379a63;
                                        color: #379a63;
                                        .dialog-msg-icon{
                                            background-image: url("./img/chat_icon_active.png");
                                        }
                                        .dialog-del-icon{
                                            background-image: url("./img/delete_icon_active.png");
                                        }
                                    }
                                    .dialog-icon{
                                        width: 20px;
                                        height: 20px;
                                        flex-shrink: 0;
                                    }
                                    .dialog-msg-icon{
                                        margin-bottom: -2px;
                                        background-image: url("./img/chat_icon.png");
                                    }
                                    .dialog-msg-text{
                                        font-size: 13px;
                                        margin-left: 6px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        flex-grow: 1;
                                        .dialog-msg-input{
                                            width: 100%;
                                            height: 20px;
                                            border: 1px solid #e5e7eb;
                                            border-radius: 3px;
                                            padding: 0 8px;
                                            font-size: 12px;
                                        }
                                    }
                                    .dialog-del-icon{
                                        margin-left: 8px;
                                        background-image: url("./img/delete_icon.png");
                                    }
                                    .dialog-edit-icon{
                                        margin-left: 8px;
                                        background-image: url("./img/edit.png");
                                    }
                                }
                            }
                            .empty-dialog{
                                padding-top: 32px;
                                .empty-icon{
                                    width: 30px;
                                    height: 30px;
                                    margin: 0 auto;
                                    background-image: url("./img/dialog_empty.png");
                                }
                                .empty-text{
                                    font-size: 12px;
                                    color: #ccc;
                                    line-height: 40px;
                                    text-align: center;
                                }
                            }
                        }
                        .slide-bottom{
                            flex-grow: 0;
                            flex-shrink: 0;
                            padding: 0 16px;
                            .slide-btn{
                                height: 46px;
                                display: flex;
                                align-items: center;
                                padding-left: 24px;
                                background-color: #dbefe4;
                                margin-bottom: 12px;
                                cursor: pointer;
                                border-radius: 5px;
                                position: relative;
                                white-space: nowrap;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                .slide-btn-icon{
                                    width: 16px;
                                    height: 16px;
                                }
                                .slide-btn-text{
                                    color: #379a63;
                                    font-size: 14px;
                                    margin-left: 9px;
                                }
                            }
                        }
                    }
                }
                .black{
                   
                    .collapse_icon{
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                        background-color: #fff;
                        border-radius: 50%;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 0 4px 2px #eee;
                        cursor: pointer;
                        &::after{
                            content: "";
                            width: 7px;
                            height: 7px;
                            border: 1px solid #666;
                            border-top: none;
                            border-right: none;
                            position: absolute;
                            top: 7px;
                            transform-origin: center center;
                        }
                        &.fold::after{
                            transform: rotate(45deg);
                            left: 8px;
                        }
                        &.unfold::after{
                            transform: rotate(225deg);
                            left: 7px;
                        }
                    }
                    .aside_wrap{
                        .slide-top{
                            border: 1px dashed #ccc;
                            color: #333;
                        }
                        .slide-list{
                            .dialog-list{
                                .dialog-item{
                                    border: 1px solid #e5e7eb;
                                    background-color: #f5f5f5;
                                    color: #333;
                                    &:hover{
                                        box-shadow: 0 0 3px 0px #ccc;
                                        border-color: #ccc;
                                    }
                                    &.active{
                                        background-color: #fff;
                                        border-color: #ccc;
                                        color: #333;
                                        .dialog-msg-icon{
                                            background-image: url("./img/chat_icon.png");
                                        }
                                        .dialog-del-icon{
                                            background-image: url("./img/delete_icon.png");
                                        }
                                    }
                                    .dialog-edit-icon{
                                        margin-left: 8px;
                                        background-image: url("/static/skin/black/edit.png");
                                    }
                                }
                            }
                            .empty-dialog{
                                .empty-icon{
                                    width: 30px;
                                    height: 30px;
                                    margin: 0 auto;
                                    background-image: url("./img/dialog_empty.png");
                                }
                                .empty-text{
                                    font-size: 12px;
                                    color: #ccc;
                                    line-height: 40px;
                                    text-align: center;
                                }
                            }
                        }
                        .slide-bottom{
                            .slide-btn{
                                background-color: #eee;
                                .slide-btn-text{
                                    color: #333;
                                }
                            }
                        }
                    }
                }
                .page_content{
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    transition: width 0.3s;
                    overflow: hidden;
                    padding-bottom: 20px;
                    .app_container{
                        padding: 0 20px;
                        .container_top{
                            height: 68px;
                            display: flex;
                            align-items: center;
                            .top_left{
                                flex-grow: 1;
                                padding-right: 20px;
                                display: flex;
                                .app_icon{
                                    width: 36px;
                                    height: 36px;
                                    margin-right: 12px;
                                    flex-shrink: 0;
                                    img{
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                                .app_info{
                                    flex-grow: 1;
                                    .app_name{
                                        font-size: 14px;
                                        line-height: 23px;
                                    }
                                    .app_desc{
                                        font-size: 11px;
                                        line-break: 21px;
                                        color: #999;
                                    }
                                }
                            }
                            .top_right{
                                flex-shrink: 0;
                                width: 160px;
                                height: 36px;
                                border: 1px solid #18a058;
                                line-height: 36px;
                                font-size: 14px;
                                text-align: center;
                                cursor: pointer;
                                color: #18a058;
                                .back_icon{
                                    width: 24px;
                                    height: 24px;
                                    display: inline-block;
                                    vertical-align: middle;
                                    background-size: 100% 100%;
                                    background-image: url("./img/back.png");
                                    margin: -3px 10px 0 0;
                                }
                            }
                        }
                        .container_area{
                            border: 2px solid #edeef7;
                            border-radius: 5px;
                            background-color: #f5f6fb;
                            .area_input{
                                display: block;
                                width: 100%;
                                height: 132px;
                                padding: 16px 20px;
                                border: none;
                                background-color: #f5f6fb;
                            }
                            .area_bottom{
                                height: 65px;
                                border-top: 1px solid #edeef7;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 0 16px;
                                .clear_btn{
                                    border: none;
                                    width: 90px;
                                    height: 34px;
                                    font-size: 14px;
                                    color: #999;
                                    background-color: #dce0f1;
                                    border-radius: 4px;
                                }
                                .area_info{
                                    line-height: 34px;
                                    font-size: 12px;
                                    color: #ccc;
                                    .words_count{
                                        padding-right: 24px;
                                    }
                                    .send_btn{
                                        width: 123px;
                                        height: 34px;
                                        background-color: #18a058;
                                        border: none;
                                        color: #fff;
                                        font-size: 14px;
                                        border-radius: 2px;
                                        &:disabled{
                                            cursor: not-allowed;
                                            opacity: 0.6;
                                        }
                                        .write_icon{
                                            width: 18px;
                                            margin-right: 12px;
                                            vertical-align: middle;
                                            margin-top: -4px;
                                        }
                                    }
                                    .black{
                                        background-color: #000;
                                    }
                                }
                            }
                        }
                        .app_center{
                            display: flex;
                            justify-content: space-between;
                            margin: 14px 0;
                            font-size: 14px;
                            line-height: 54px;
                            .app_nav{
                                display: flex;
                                .nav_item{
                                    border-bottom: 1px dotted #999999;
                                    color: #999;
                                    cursor: pointer;
                                    &:not(:last-child){
                                        margin-right: 54px;
                                    }
                                    &.active{
                                        color: #18a058;
                                        border-color: #18a058;
                                    }
                                }
                            }
                            .open_vip{
                                color: #18a058;
                                border-bottom: 1px dotted #18a058;
                                width: 435px;
                                display: flex;
                                align-items: center;
                                .vip_icon{
                                    width: 18px;
                                    height: 18px;
                                    display: block;
                                    margin-right: 10px;
                                    flex-shrink: 0;
                                }
                                .vip_text{
                                    flex-grow: 1;
                                }
                                .pay_btn{
                                    flex-shrink: 0;
                                    width: 58px;
                                    height: 22px;
                                    border: none;
                                    background-color: #cff8e2;
                                    font-size: 12px;
                                    border-radius: 2px;
                                    color: #18a058;
                                }
                            }
                        }
                        .example_part{
                            .example_item{
                                margin-bottom: 12px;
                                font-size: 14px;
                                line-height: 24px;
                                color: #333;
                                &:hover{
                                    .use_btn{
                                        display: inline-block;
                                    }
                                }
                                .example_num{
                                    font-weight: bold;
                                }
                                .use_btn{
                                    margin-left: 20px;
                                    height: 20px;
                                    padding: 0 8px;
                                    font-size: 12px;
                                    color: #18a058;
                                    border: 1px dotted #18a058;
                                    background-color: transparent;
                                    border-radius: 2px;
                                    display: none;
                                }
                            }
                        }
                    }
                    .black{
                        .container_top {
                            .top_right{
                                color: #000;
                                border: 1px solid #000;
                                .back_icon{
                                    background-size: 100% 100%;
                                    background-image: url("/static/skin/black/back.png");
                                    margin: -3px 10px 0 0;
                                }
                            }               
                        } 
                        .app_center{
                            .app_nav{
                                .nav_item{
                                    &.active{
                                        color: #333;
                                        border-color: #333;
                                    }
                                }
                            }
                            .open_vip{
                                border-bottom: 1px dotted #333;
                                .vip_text{
                                    color: #333;
                                }
                                .pay_btn{
                                    background-color: #eee;
                                    color: #333;
                                }
                            }
                        }        
                        .container_area {
                            .area_bottom {

                                .area_info {
                                    .send_btn{
                                        background-color: #000;
                                    }
                                }
                            }
                        }
                    }
                    .content_body{
                        flex-grow: 1;
                        overflow-y: scroll;
                        padding: 15px;
                        margin-right: -17px;
                        .show_banner{
                            padding: 20px 0;
                            .chat-title{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #333;
                                font-size: 34px;
                                font-weight: 700;
                                height: 63px;
                            }
                            .tips-content{
                                display: flex;
                                flex-wrap: wrap;
                                justify-content: space-between;
                                padding-top: 5vh;
                                color: #666;
                                .tip_title{
                                    flex-grow: 1;
                                    width: 33.3%;
                                    padding-bottom: 24px;
                                    text-align: center;
                                    .tip_title_icon{
                                        display: block;
                                        margin: 0 auto;
                                        width: 32px;
                                    }
                                    .tititle_label{
                                        font-size: 18px;
                                        line-height: 48px;
                                    }
                                }
                                .tips-item{
                                    flex-grow: 1;
                                    width: 33.3%;
                                    padding: 0 2vw 10px;
                                    .tips-item-content{
                                        background-color: #f7f7f7;
                                        border-radius: 3px;
                                        height: 38px;
                                        line-height: 38px;
                                        text-align: center;
                                        overflow: hidden;
                                        padding: 0px 12px;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        font-size: 14px;
                                        cursor: pointer;
                                    }
                                }
                            }
                            .qun_ad{
                                display: flex;
                                background-color: #f7f7f7;
                                border-radius: 8px;
                                padding: 10px;
                                height: 360px;
                                display: flex;
                                margin: 20px 2vw 0;
                                .code_content{
                                    flex-grow: 1;
                                    background-color: #fff;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                    .qun_top{
                                        display: flex;
                                        padding-bottom: 2px;
                                        margin: 0 auto 26px;
                                        .qun_head{
                                            width: 44px;
                                            height: 44px;
                                            display: block;
                                            margin-right: 12px;
                                            flex-shrink: 0;
                                        }
                                        .qun_info{
                                            flex-grow: 1;
                                            .qun_name{
                                                font-size: 16px;
                                                line-height: 20px;
                                                margin-bottom: 5px;
                                                span{
                                                    color: #c00;
                                                }
                                            }
                                            .qun_desc{
                                                font-size: 14px;
                                                color: #999;
                                                line-height: 18px;
                                            }
                                        }
                                    }
                                    .qun_code{
                                        display: block;
                                        width: 144px;
                                        margin-bottom: 20px;
                                    }
                                    .qun_label{
                                        font-size: 14px;
                                        color: #c00;
                                        line-height: 30px;
                                    }
                                }
                                .qun_tips{
                                    width: 40%;
                                    padding-left: 30px;
                                    .tips_title{
                                        padding-top: 6px;
                                        text-align: center;
                                        font-size: 18px;
                                        line-height: 100px;
                                    }
                                    p{
                                        font-size: 14px;
                                        line-height: 22px;
                                        color: #666;
                                        margin-bottom: 22px;
                                    }
                                }
                            }
                        }
                        .msg-wrap{
                            padding: 0 20px;
                            .msg-content{
                                display: flex;
                                margin-bottom: 12px;
                                padding: 14px 0;
                                .text_content{
                                    flex-grow: 1;
                                }
                                .msg-userinfo{
                                    color: #333;
                                    font-size: 14px;
                                    font-weight: bold;
                                    span{
                                        font-size: 12px;
                                        line-height: 16px;
                                        color: #999;
                                        font-weight: normal;
                                        padding: 0 10px;
                                    }
                                }
                                .msg-userinfo_left{
                                    margin-left: 10px;
                                }
                                .msg-userinfo_right{
                                    margin-right: 10px;
                                    text-align: right;
                                }
                                &.right{
                                    flex-direction: row-reverse;
                                    .content-item{
                                        margin-right: 10px;
                                        justify-content: flex-end;

                                    }
                                    .copy-item{
                                        margin-right: 10px;
                                    }
                                    .msg-text{
                                        background-color: #dbefe4;
                                        &::before{
                                            border-left-color: #dbefe4!important;
                                            right: -12px;
                                        }
                                    }
                                }
                                &.left{
                                    .content-item{
                                        margin-left: 10px;
                                        flex-direction: row-reverse;
                                    }
                                    .copy-item{
                                        margin-left: 10px;
                                    }
                                    .msg-text{
                                        background-color: #f5f6fb;
                                        color: #505673;
                                        &::before{
                                            border-right-color: #f5f6fb!important;
                                            left: -12px;
                                        }
                                    }
                                    .vipPopShow{
                                        color: #d03050;
                                    }
                                }
                                .user-img {
                                    width: 35px;
                                    height: 35px;
                                    border-radius: 50%;
                                    flex-shrink: 0;
                                }
                                .content-item{
                                    display: flex;
                                    &.fullline{
                                        flex-grow: 1;
                                        .msg-text{
                                            flex-grow: 1;
                                        }
                                    }
                                    .copy-item{
                                        position: relative;
                                        width: 30px;
                                        height: 30px;
                                        flex-shrink: 0;
                                        background-color: #f5f6fb;
                                        border-radius: 15px;
                                        margin-top: 3px;
                                        cursor: pointer;
                                        align-self: flex-end;
                                        .copy-icon {
                                            width: 14px;
                                            height: 14px;
                                            position: absolute;
                                            right: 8px;
                                            bottom: 8px;
                                        }
                                    }
                                    .msg-text{
                                        border-radius: 10px;
                                        font-size: 13px;
                                        padding: 8px 10px;
                                        line-height: 20px;
                                        white-space: pre-line;
                                        position: relative;
                                        &::before{
                                            content: "";
                                            display: block;
                                            position: absolute;
                                            border: 6px solid transparent;
                                            top: 12px;
                                        }
                                        &.detail_loading{
                                            align-items: center;
                                            display: flex;
                                        }
                                        .loading_icon{
                                            width: 18px;
                                            height: 18px;
                                            margin-right: 4px;
                                            animation: rotate 2s linear infinite;
                                        }
                                        &.typeing:after{
                                            margin-left:5px;
                                            content:"▋";
                                            animation:cursor-animation 1s infinite;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .content_footer{
                        padding: 16px;
                        .footer_wrap{
                            max-width: 64rem;
                            width: 100%;
                            margin: auto;
                            display: flex;
                            align-items: flex-end;
                            justify-content: space-between;
                            .footer_icon{
                                margin-right: 8px;
                                position: relative;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex-shrink: 0;
                                width: 40px;
                                height: 40px;
                                cursor: pointer;
                                &:hover{
                                    .icon_tips{
                                        display: block;
                                    }
                                }
                                .icon_tips{
                                    position: absolute;
                                    z-index: 10;
                                    display: inline-block;
                                    left: 50%;
                                    bottom: 10px;
                                    transform: translate(-50%,-100%);
                                    display: none;
                                    background: #303133;
                                    color: #fff;
                                    border-radius: 4px;
                                    padding: 6px 16px;
                                    white-space: nowrap;
                                    line-height: 1.5;
                                    &::after{
                                        content: "";
                                        display: block;
                                        border: 8px solid transparent;
                                        border-top-color: #303133;
                                        position: absolute;
                                        bottom: -16px;
                                        left: 50%;
                                        margin-left: -8px;
                                    }
                                }
                            }
                            .footer_main{
                                margin-right: 8px;
                                flex-grow: 1;
                                .footer_top{
                                    padding-bottom: 8px;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    .footer_top_left{
                                        display: flex;
                                    }
                                    .tool_btn{
                                        padding: 8px 20px 8px 12px;
                                        border: 1px solid #e5e7eb;
                                        border-radius: 24px;
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                        position: relative;
                                        margin-left: 24px;
                                        &:first-child{
                                            margin-left: 0;
                                        }
                                        .tool_btn_icon{
                                            width: 18px;
                                            height: 18px;
                                            display:block;
                                        }
                                        .tool_btn_text{
                                            margin-left: 4px;
                                            font-size: 14px;
                                            line-height: 1.6;
                                        }
                                        .btn_badge{
                                            background-color: #d03050;
                                            color: #FFF;
                                            position: absolute;
                                            height: 18px;
                                            line-height: 18px;
                                            border-radius: 9px;
                                            padding: 0 6px;
                                            font-size: 12px;
                                            transform: translateX(-50%);
                                            left: 100%;
                                            bottom: calc(100% - 9px);
                                            z-index: 1;
                                        }
                                    }
                                    .select_question{
                                        display: flex;
                                        flex-shrink: 0;
                                        align-items: center;
                                        margin-left: 24px;
                                        padding: 5px 6px;
                                        background-color: rgb(255, 219, 196);
                                        border: 1px solid rgb(255, 114, 44);
                                        border-radius: 6px;
                                        margin-right: 8px;
                                        font-size: 14px;
                                        line-height: 1.6;
                                        color: rgb(255, 114, 44);
                                        svg{
                                            margin-left: 8px;
                                            cursor: pointer;
                                            display: block;
                                            vertical-align: middle;
                                        }
                                    }
                                    .tool_btn_share{
                                        padding: 8px 20px 8px 12px;
                                        border: 1px solid #e5e7eb;
                                        border-radius: 24px;
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                        position: relative;
                                        .tool_btn_icon{
                                            width: 18px;
                                            height: 18px;
                                            display:block;
                                        }
                                        .tool_btn_text{
                                            margin-left: 4px;
                                            font-size: 14px;
                                            line-height: 1.6;
                                        }
                                        .btn_badge{
                                            background-color: #d03050;
                                            color: #FFF;
                                            position: absolute;
                                            height: 18px;
                                            line-height: 18px;
                                            border-radius: 9px;
                                            padding: 0 6px;
                                            font-size: 12px;
                                            transform: translateX(-50%);
                                            left: 100%;
                                            bottom: calc(100% - 9px);
                                            z-index: 1;
                                        }
                                    }
                                }
                                .input_wrap{
                                    position: relative;
                                    .input_area{
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        height: 100%;
                                        width: 100%;
                                        padding: 6px 12px;
                                        word-break: break-word;
                                        display: inline-block;
                                        vertical-align: bottom;
                                        line-height: 1.7;
                                        resize: none;
                                        white-space: pre-wrap;
                                        caret-color: #18a058;
                                        border: 1px solid #e5e7eb;
                                        border-radius: 3px;
                                        &:focus{
                                            border-color: #36ad6a;
                                            box-shadow:  0 0 5px 0px #82efb2;
                                        }
                                    }
                                    .input_place{
                                        min-height: 34px;
                                        max-height: 192px;
                                        height: 100%;
                                        width: 100%;
                                        padding: 6px 12px;
                                        pointer-events: none;
                                        overflow: hidden;
                                        visibility: hidden;
                                        position: static;
                                        white-space: pre-wrap;
                                        overflow-wrap: break-word;
                                        word-break: break-word;
                                        display: inline-block;
                                        vertical-align: bottom;
                                        line-height: 1.7;
                                        resize: none;
                                        border: 1px solid #e5e7eb;
                                    }
                                }
                            }
                            .send_btn{
                                background-color: #18a058;
                                padding: 0 14px;
                                height: 34px;
                                font-size: 14px;
                                border-radius: 3px;
                                color: #fff;
                                white-space: nowrap;
                                outline: none;
                                position: relative;
                                z-index: auto;
                                border: none;
                                display: inline-flex;
                                flex-wrap: nowrap;
                                flex-shrink: 0;
                                align-items: center;
                                justify-content: center;
                                user-select: none;
                                text-align: center;
                                cursor: pointer;
                                &:disabled{
                                    cursor: not-allowed;
                                    opacity: 0.6;
                                }
                                img{
                                    width: 24px;
                                }
                            }
                        }
                        .black{
                            .footer_main{
                                .input_wrap{
                                    .input_area{
                                        &:focus{
                                                border-color: #ccc;
                                                box-shadow:  0 0 5px 0px #ccc;
                                            }
                                    }
                                }
                            }
                            .send_btn{
                                background-color: #000;
                            }
                        }
                    }
                }
                .page_right_aside{
                    width: 320px;
                    flex-shrink: 0;
                    box-shadow: 0 0 14px 4px #ccc;
                    transition: width 0.3s;
                    position: relative;
                    &.hide{
                        width: 0;
                        box-shadow: none;
                    }
                    .collapse_icon{
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        left: -12px;
                        width: 24px;
                        height: 24px;
                        background-color: #fff;
                        border-radius: 50%;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 0 4px 2px #eee;
                        cursor: pointer;
                        &::after{
                            content: "";
                            width: 7px;
                            height: 7px;
                            border: 1px solid #666;
                            border-top: none;
                            border-right: none;
                            position: absolute;
                            top: 7px;
                            transform-origin: center center;
                        }
                        &.fold::after{
                            transform: rotate(225deg);
                            left: 6px;
                        }
                        &.unfold::after{
                            transform: rotate(45deg);
                            left: 7px;
                        }
                    }
                }
            }
        }
    }
	@keyframes rotate {
	    0% {
			transform: rotate(0deg);
		}
		25% {
			transform: rotate(90deg);
		}
		50% {
			transform: rotate(180deg);
		}
		75% {
			transform: rotate(270deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
    @keyframes cursor-animation{
        0%{opacity:0}
        50%{opacity:1}
        to{opacity:0}
    }
</style>